
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_1q16i_97",
  "mobile-bar": "awsui_mobile-bar_19d8l_1q16i_101",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_1q16i_114",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_1q16i_121",
  "mobile-toggle-type-navigation": "awsui_mobile-toggle-type-navigation_19d8l_1q16i_129",
  "mobile-toggle-type-tools": "awsui_mobile-toggle-type-tools_19d8l_1q16i_132",
  "mobile-toggle-type-drawer": "awsui_mobile-toggle-type-drawer_19d8l_1q16i_132",
  "drawers-container": "awsui_drawers-container_19d8l_1q16i_139"
};
  